import React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import QuestionTabs from './QuestionTabs';
import { Col } from 'reactstrap';
import EditIcon from '@material-ui/icons/Edit';
import SystemLabel from '../../../../../system/SystemLabel/SystemLabel';
import { IconButton, Tooltip } from '@material-ui/core';
import EditQuestion from './EditQuestion';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete'
import RestoreIcon from '@material-ui/icons/Restore';
import ConfirmModal from '../../../../../components/ConfirmModal/ConfirmModal';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
const savableStyle = {
    backgroundColor: '#05bf052e',
    color: '#0abd0a'
};

export default function QuestionOverview(props) {
    const [editView, showEditView] = React.useState(false);
    const [isSavable, setSavable] = React.useState(false);
    const [saveRequest, setSave] = React.useState(false);
    const [deleteRequest, setDelete] = React.useState(false);
    const [open, toggleModal] = React.useState(false)

    const { clientResponses, sendResponse, clear, textEditing, questionName, active, activeQuestions, removeClientData, eventId, clearQuestionAnswers, selectedQuestion } = props;
    const savable = (status) => {
        setSavable(status)
    }
    const restore = () => {
        toggleModal(false)
        clearQuestionAnswers(props.selectedQuestion.questionId)
    }
    const isDeleteable = (activeQuestions.find(aq => aq == props.selectedQuestion.questionId) === undefined);
    return (
        <Card className="dark-card" style={{ margin: 10, height: 'calc(100% - 10px)', paddingRight: 5 }}>
            <CardContent style={{ minHeight: 'calc(100% - 40px)', maxHeight: 'calc(100% - 40px)', }}>
                <div className="inline-flex" style={{ width: '100%', padding: '0px', margin: '10px 0px', display: 'inline-flex' }}>
                    <Col className="col-6 text-left" style={{ padding: 0 }}>
                        <Typography variant="h6" className="primary-text ellipsis">
                            {active ? questionName : <SystemLabel name="NoQuestionSelected" />}
                            {selectedQuestion.eventId != eventId ? <React.Fragment>
                                <div style={{ opacity: 0.8, fontSize: '15px' }}>
                                    <ErrorOutlineIcon />{"  "} <SystemLabel name="InheritedQuestionsCanNotBeEdited" />
                                </div>
                            </React.Fragment> : null}
                        </Typography>
                    </Col>
                    <Col className="col-6 text-right" style={{ padding: 0 }}>
                        {editView && selectedQuestion.eventId == eventId ? <React.Fragment>
                            <IconButton className="icon-button-dark" disabled={!isDeleteable} style={{
                                padding: 15,
                                margin: '0px 10px',
                                opacity: selectedQuestion.eventId != eventId ? 0.6 : 1
                            }}

                                onClick={() => setDelete(true)}
                                edge="end">
                                <DeleteIcon />
                            </IconButton>

                            <IconButton className="icon-button-dark" disabled={!isSavable} style={{
                                padding: 15,
                                margin: '0px 10px',
                                opacity: !isSavable ? 0.6 : 1
                            }} onClick={() => setSave(true)} edge="end">
                                <SaveIcon />
                            </IconButton>
                            <IconButton className="icon-button-dark" style={{ padding: 15, margin: '0px 10px' }} onClick={() => showEditView(!editView)} edge="end">
                                <CloseIcon />
                            </IconButton>
                        </React.Fragment> :
                            <React.Fragment>
                                <Tooltip title={<SystemLabel name="ClearQuestionAnswers" />}>
                                    <IconButton className="icon-button-dark" style={{
                                        padding: 15,
                                        margin: '0px 10px'
                                    }}
                                        onClick={() => toggleModal(true)}
                                        edge="end">
                                        <RestoreIcon />
                                    </IconButton>
                                </Tooltip>
                                <IconButton
                                    disabled={selectedQuestion.eventId != eventId}
                                    className="icon-button-dark" style={{ padding: 15, margin: '0px 10px', opacity: selectedQuestion.eventId != eventId ? 0.6 : 1 }}
                                    onClick={() => showEditView(!editView)} edge="end">
                                    <EditIcon />
                                </IconButton>
                            </React.Fragment>
                        }

                    </Col>
                </div>
                {open ? (
                    <ConfirmModal
                        open={open}
                        header={'AreYouSure'}
                        text={'DoYouWannaDeleteAllAnswersOnThisQuestion'}
                        onCancel={() => toggleModal(false)}
                        onAction={restore} />
                ) : null}

                {editView ? <EditQuestion deleteRequest={deleteRequest} saveRequest={saveRequest} closeSaveRequest={() => setSave(false)} closeDeleteRequest={() => setDelete(false)} setSavable={savable} {...props} /> : <QuestionTabs {...props} />}
            </CardContent>
        </Card>


    );
}